var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoReadNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#FFE492",
    fillOpacity: 0.26
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13104_66016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13104_66016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15.9999H16V47.9999H48V15.9999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13104_66016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13104_66016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 15,
    width: 32,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9998H48V47.9998H16V15.9998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13104_66016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 37.3123H26.1248H26.125L28 39.9373H35.8125L37.6875 37.3123H46.0625",
    stroke: "#6B4F30",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0971 26.7498L44.7688 24.7633C44.4695 22.9528 42.904 21.6248 41.0689 21.6248H39.125",
    stroke: "#6B4F30",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0269 32.3748L46.75 37.3123V42.9998C46.75 45.0708 45.0711 46.7498 43 46.7498H21C18.9289 46.7498 17.25 45.0708 17.25 42.9998V37.3123L19.2312 24.7633C19.5305 22.9528 21.096 21.6248 22.9311 21.6248H24.625",
    stroke: "#6B4F30",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1875 25.3123L35.6875 17.8123",
    stroke: "#6B4F30",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 25.3123L28.1875 17.8123",
    stroke: "#6B4F30",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13104_66016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReadNotificationsIcon);
export default __webpack_public_path__ + "static/media/noReadNotificationsIcon.b714df2252ea8fc91998ef8e7a9070bc.svg";
export { ForwardRef as ReactComponent };